import {useInitiateCheckout} from "./hooks/use-initiate-checkout"
import {useFormAction} from "./hooks/use-form-action"
import './styles.scss'
import {Spinner} from "@malwarebytes/react-components"
import { useTranslation } from "react-i18next"

export const ChaseConnector = () => {
    const { isInitiated, isError } = useInitiateCheckout()

    const formAction = useFormAction()

    const { t } = useTranslation()

    if (isError) {
        return (
            <div className='chase-loader'>
                <h3>
                    {t('apiErrors.checkoutInitiationFailed')}
                </h3>
            </div>
        )
    }

    if (!isInitiated || !formAction) {
        return (
            <div className='chase-loader'>
                <Spinner />
                <h3>
                    {t('form.preparing')}
                </h3>
            </div>
        )
    }

    return (
        <div className='px-3'>
            <form action={formAction} className='paymentWidgets' data-brands='VISA MASTER MAESTRO'/>
        </div>
    )
}